import $ from 'jquery';
import { isRtl, isMobile } from '../../_shared/helpers';

export default class FlyOuts {
  constructor($header) {
    this.$window = $(window);
    this.$document = $(document);
    this.$header = $header;
    this.isRtl = isRtl();
    this.isMobile = isMobile();

    this.$activeFlyOut = null;
    this.eventHandlers = null;
    this.isEnabled = false;
    this.timerId = 0;
  }

  init() {
    this.findElements(this.$header);

    if (!this.$flyOuts.length && !this.$selectedFlyTriggers.length) {
      return;
    }

    this.enable();
  }

  findElements() {
    this.$flyOuts = this.$header.find('.js-header-fly-out:not(.is-selected)');
    this.$selectedFlyTriggers = this.$header.find('.js-header-fly-out.is-selected .js-header-fly-trigger');
    this.$flyTrigger = this.$flyOuts.find('.js-header-fly-trigger');
  }

  open($el) {
    if (this.$activeFlyOut) {
      if ($el[0] === this.$activeFlyOut[0] && this.isMobile) {
        this.close(this.$activeFlyOut);
        return;
      }
      this.close(this.$activeFlyOut);
    }

    const $dropDown = $el.find('.js-header-drop-down');
    const hasSpaceFromLeft = $dropDown.offset().left >= 0;
    const hasSpaceFromRight = (this.$window.width() - ($dropDown.offset().left + $dropDown.outerWidth())) >= 0;

    const checkVerticalSpace = () => {
      const MIN_BOTTOM_SPACE = 20;
      const MIN_DROP_DOWN_LIST_HEIGHT = 60;

      const dropDownHeight = $dropDown.outerHeight();
      // eslint-disable-next-line max-len
      const bottomSpace = this.$window.outerHeight() - ($dropDown.offset().top - this.$document.scrollTop() + dropDownHeight + MIN_BOTTOM_SPACE);

      if (bottomSpace < 0) {
        const dropDownList = $dropDown.find('.js-header-drop-down-list');
        const dropDownListHeight = dropDownList.outerHeight();

        const maxHeight = dropDownListHeight + bottomSpace;

        dropDownList.css({
          'overflow-y': 'auto',
          'max-height': maxHeight < MIN_DROP_DOWN_LIST_HEIGHT ? MIN_DROP_DOWN_LIST_HEIGHT : maxHeight,
        });
      }
    };

    checkVerticalSpace();

    if (hasSpaceFromLeft && hasSpaceFromRight) {
      $el.addClass('is-active');
    } else if (hasSpaceFromLeft) {
      $el.addClass(this.isRtl ? 'is-active is-active--to-right' : 'is-active is-active--to-left');
    } else if (hasSpaceFromRight) {
      $el.addClass(this.isRtl ? 'is-active is-active--to-left' : 'is-active is-active--to-right');
    }

    $el.find('.js-header-fly-trigger').attr('aria-expanded', 'true');

    this.$activeFlyOut = $el;
  }

  close($el) {
    $el.removeClass('is-active is-active--to-left is-active--to-right');

    const dropDownList = $el.find('.js-header-drop-down-list');

    dropDownList.scrollTop(0);
    dropDownList.removeAttr('style');

    $el.find('.js-header-fly-trigger').attr('aria-expanded', 'false');

    this.$activeFlyOut = null;

    clearTimeout(this.timerId);
  }

  enable() {
    const ESCAPE_KEY_CODE = 27;
    const SPACE_KEY_CODE = 32;

    this.eventHandlers = [
      [
        this.$flyOuts,
        {
          mouseover: (event) => {
            if (!this.isMobile && event.currentTarget !== event.relatedTarget
              && !this.$flyOuts.has(event.relatedTarget).length) {
              this.open($(event.currentTarget));

              clearTimeout(this.timerId);
            }
          },
          mouseleave: (event) => {
            if (!this.isMobile) {
              this.timerId = setTimeout(() => {
                this.close($(event.currentTarget));
              }, 1000);
            }
          },
        },
      ],
      [
        this.$flyTrigger,
        {
          click: (event) => {
            const $closestFlyOut = $(event.currentTarget).closest(this.$flyOuts);

            if ($closestFlyOut.length) {
              event.preventDefault();
              this.open($closestFlyOut);
            }
          },
        },
      ],
      // [
      //   this.$selectedFlyTriggers,
      //   {
      //     click: (event) => {
      //       event.preventDefault();
      //     },
      //   },
      // ],
      [
        this.$document,
        {
          click: (event) => {
            if (
              this.$flyOuts.has(event.target).length === 0 && !this.$flyOuts.is(event.target)
            ) {
              this.close(this.$flyOuts);
            }
          },
          keyup: (event) => {
            if (event.keyCode === ESCAPE_KEY_CODE) {
              this.close(this.$flyOuts);
            }
          },
          keydown: (event) => {
            if (
              event.keyCode === SPACE_KEY_CODE && this.$flyTrigger.is(document.activeElement)
            ) {
              event.preventDefault();

              $(document.activeElement).click();
            }
          },
        },
      ],
    ];

    this.eventHandlers.forEach((pair) => pair[0].on(pair[1]));

    this.isEnabled = true;
  }
}
